import { FunctionComponent } from 'react'
import TeaserImage from '../TeaserImage'
import TeaserVideoInfo from '../TeaserVideoInfo'
import ToiTeaserComponents from '@components/Teaser/Toi'
import { TOITeaserAPIProps } from '../types'
import { ImageCrops, TeaserVideo } from '../../types'
import { UseViewportTracking } from '@hooks/useViewportTracking'

interface OpinionTOILayoutProps
  extends Pick<
    TOITeaserAPIProps,
    'labelText' | 'title' | 'catchword' | 'subtitle'
  > {
  clickableProps: Record<string, unknown>
  imageSrc: string
  imageAlt: string
  imageAvailableCrops?: ImageCrops
  video?: TeaserVideo
  viewportRef: ReturnType<UseViewportTracking>
}

const {
  Catchword,
  EverythingWrapper,
  InnerTextWrapper,
  Label,
  OuterTextWrapper,
  OuterWrapper,
  Subtitle,
  TextLine,
  TextWrapper,
  Title,
} = ToiTeaserComponents

const OpinionTOILayout: FunctionComponent<OpinionTOILayoutProps> = ({
  labelText,
  title,
  catchword,
  subtitle,
  clickableProps,
  imageSrc,
  imageAlt,
  imageAvailableCrops,
  video,
  viewportRef,
}) => (
  <EverythingWrapper viewportRef={viewportRef}>
    <OuterWrapper clickableProps={clickableProps}>
      <TeaserImage
        src={imageSrc}
        alt={imageAlt}
        availableCrops={imageAvailableCrops}
      />
      <TextLine />
      <TextWrapper>
        <TeaserVideoInfo video={video} isStandalone={true} />
        <OuterTextWrapper>
          <InnerTextWrapper>
            <TeaserVideoInfo video={video} isStandalone={false} />
            {labelText && <Label>{labelText}</Label>}
            {catchword ? <Catchword>{catchword}</Catchword> : null}
            <Title>{title}</Title>
            {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
          </InnerTextWrapper>
        </OuterTextWrapper>
      </TextWrapper>
    </OuterWrapper>
  </EverythingWrapper>
)

export default OpinionTOILayout
